import { gql } from "@apollo/client";

export const GET_ALL_GROUP_CHAT_LIST = gql`
query getGroupChats {
  getChats {
    chatId
    chatType
    chatroomId
    chatroomName
  }
}`;

export const SEARCH_CHAT_LIST = gql`
query allClassroomUsers($cId: UUID!,$input:String! = "%", $limit: Int = null, $offset: Int = null,$uId:UUID!,$sjId: UUID!) {
  allUsers(
    filter: {and: [
      {
        teachersByUId: 
        {
          every: 
          {
            and: 
            [
              {
                teacherClassroomsByTId: 
                {
                  some: 
                  {
                    classroomByCId: 
                    {
                      cId: 
                      {equalTo: $cId}
                    }
                  }
                }
              },
              {
                teacherClassroomsByTIdExist: true
              },
              {
                teacherSubjectsByTId:{
                  some:{
                    and:[
                      {
                        sjId:{equalTo:$sjId}
                      },{
                        deletedAt:{isNull:true}
                      }
                    ]
                  }
                }
              }
            ]
          }
        }
      }
      , 
      {studentsByUId:
        {
          every: 
          {
            and: 
            [
                    {
                studentClassroomsBySId: {some: {classroomByCId: {cId: {equalTo: $cId}}}}},
              {studentClassroomsBySIdExist: true}
            ]
          }
        }
      },
      {
        schoolAdminsByUIdExist:false
      },
      {
        uFullName:{likeInsensitive:$input}
      },
      {
        deletedAt:{isNull:true}
      },
      {
        uId:{notEqualTo:$uId}
      },
      {
        uRole:{notIn:[SCHOOLADMIN,PTA]}
      }
    ]}
    first: $limit
    offset: $offset
    orderBy: U_FULL_NAME_ASC
  ) {
    nodes {
      uFullName
      uRole
      uEmailId
      uId
      teachersByUId {
        nodes {
          tAvatarUrl
          tId
          tName
          teacherClassroomsByTId {
            nodes {
              cId
            }
          }
        }
      }
      studentsByUId {
        nodes {
          sAvatarUrl
          sId
          uId
          studentClassroomsBySId {
            nodes {
              cId
            }
          }
        }
      }
    }
    totalCount
  }
}`;

export const GET_ALL_CHAT_LIST = gql`
query getIndividualChatList($input: getIndividualChatInput!) {
  getIndividualChatList(input: $input) {
    nodes {
      chatId
      from
      to
      chatroomId
      chatType
      unReadMessagesCount
    }
    totalCount
  }
}`;

export const ADD_INDIVIDUAL_CHAT=gql`
mutation insertIndividualChatList($input: individualInput!) {
  insertIndividualChatList(input: $input)
}`;

export const UPDATE_LAST_MESSAGE= gql`
mutation updateLastMessateForChat($chatId: UUID!, $lastMessageSendAt: Datetime!) {
  updateChatByChatId(
    input: {chatPatch: {lastMessageSendAt: $lastMessageSendAt}, chatId: $chatId}
  ) {
    clientMutationId
  }
}`;

export const UPDATE_ACTIVE_STATUS = gql`
mutation updateUserChatStstus($chatActive: Boolean!) {
  updateUserChatStstus(chatActive: $chatActive)
}`;

export const GET_CONFIGURED_SUBJECTS_CHATS = gql`
query getConfiguredSubjectsForChat($cId: UUID!) {
  getConfiguredSubjectsForChat(cId: $cId) {
    sjId
    sjName
    sjOriginalName
    sjColorCode
    unreadMsgCount
    sessionExists
    subjectAvatarUrl
  }
}
`;
